import { STAGES } from "@/lib/mh";

export const DW = 1800, DH = 1020;
export const mid = (a) => { const v = a.tailored?.value; return v ? ((v.money_low || 0) + (v.money_high || 0)) / 2 : 0; };
export const midHours = (a) => { const v = a.tailored?.value; return v ? ((v.hours_low || 0) + (v.hours_high || 0)) / 2 : 0; };
export const reduceMotion = () => window.matchMedia("(prefers-reduced-motion: reduce)").matches;
export const isTouch = () => window.matchMedia("(hover: none)").matches || "ontouchstart" in window;

export const HUB = { x: 760, y: 880 };
const BRANCH = { Foundation: [188, 0.03], Capture: [-124, 0.015], Generate: [-62, -0.012], Orchestrate: [-8, -0.016] };

export function deptLayout(agents) {
  const nodes = [], labels = [];
  STAGES.forEach((s) => {
    const [deg, bend] = BRANCH[s];
    const list = agents.filter((a) => a.stage === s);
    let x = HUB.x, y = HUB.y, t = (deg * Math.PI) / 180;
    list.forEach((a, k) => {
      const step = k ? 115 : 130;
      x += Math.cos(t) * step; y += Math.sin(t) * step;
      const z = k % 2 ? 30 : -30;
      nodes.push({ ...a, i: nodes.length, k, x: x - Math.sin(t) * z, y: y + Math.cos(t) * z });
      t += bend * 4;
    });
    const off = s === "Foundation" ? 110 : 95;
    labels.push({ stage: s, count: list.length, x: x + Math.cos(t) * off, y: y + Math.sin(t) * off - (s === "Orchestrate" ? 10 : 0) });
  });
  return { nodes, labels };
}

export function linkIndex(agents) {
  const req = {}, en = {}, rel = {};
  agents.forEach((a) => {
    req[a.slug] = (a.dependencies || []).map((d) => d.dependency_agent_slug);
    rel[a.slug] = a.related_agents || [];
    req[a.slug].forEach((d) => { (en[d] = en[d] || []).push(a.slug); });
  });
  return { req: (s) => req[s] || [], en: (s) => en[s] || [], rel: (s) => rel[s] || [] };
}

export const roleStatus = (a, needsDept) =>
  a.runtime?.status === "live" ? "running" : a.tailored && !a.tailored.enabled ? "inactive" : a.tailored?.needs_input || needsDept ? "needs" : "active";
export const STATUS_LABEL = { running: "Running", active: "Active", inactive: "Inactive", needs: "Needs input" };
export const STATUS_COLOR = { running: "#D4FF3A", active: "#E8E8EE", inactive: "#5A5A66", needs: "#FFB020" };

export function deptTotals(list, status) {
  const on = list.filter((a) => (a.tailored ? a.tailored.enabled : a.runtime?.status === "live"));
  const waves = list.filter((a) => a.tailored?.enabled && a.tailored.wave && a.runtime?.status !== "live").map((a) => a.tailored.wave);
  return {
    active: on.length, total: list.length,
    hours: on.reduce((s, a) => s + midHours(a), 0), money: on.reduce((s, a) => s + mid(a), 0),
    needs: list.filter((a) => status(a) === "needs").length, wave: waves.length ? Math.min(...waves) : null,
    tailored: list.some((a) => a.tailored),
  };
}

export const RUNGS = [
  ["Human-led", 0.35, "You lead every call; the agent drafts and does the legwork.", "#9A9AAE"],
  ["Human-assisted", 0.65, "The agent does the work; you review and approve before it ships.", "#FFB020"],
  ["Fully autonomous", 0.9, "It runs end-to-end inside guardrails; you audit by exception only.", "#00E5FF"],
];
export const RUNG_KEY = { "Human-led": "human_led", "Human-assisted": "human_assisted", "Fully autonomous": "fully_autonomous" };

export function savings(a, rate) {
  const rec = RUNGS.find((r) => r[0] === a.autonomy) || RUNGS[1];
  const hm = midHours(a);
  const manual = hm ? hm / 4.33 / rec[1] : 9;
  return { manual, tailored: !!hm, rungs: RUNGS.map(([level, pct, keeps, color]) => ({ level, pct, keeps, color, h: manual * pct, m: manual * pct * rate * 4.33 })) };
}

export const usd = (n) => `$${Math.round(n || 0).toLocaleString()}`;
